import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { TechnicalInstallation } from '../../model/technical-installations.model';
import { getInstallations, updateAnnouncement } from '../../store/technical-installation.action';
import { DialogService } from '../../../shared/service/dialog.service';
import { AnnouncementFormDialogComponent } from '../announcement-form-dialog/announcement-form-dialog.component';
import { BehaviorSubject, firstValueFrom } from 'rxjs';
import { map } from 'rxjs/operators';
import { selectTechnicalInstallations } from '../../store/building.selector';
import { TranslocoDirective } from '@jsverse/transloco';
import { MatIcon } from '@angular/material/icon';
import {
  MatTable,
  MatColumnDef,
  MatHeaderCellDef,
  MatHeaderCell,
  MatCellDef,
  MatCell,
  MatHeaderRowDef,
  MatHeaderRow,
  MatRowDef,
  MatRow,
} from '@angular/material/table';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { AsyncPipe, DatePipe } from '@angular/common';

@Component({
  selector: 'sibat-installation-list',
  templateUrl: './installation-list.component.html',
  styleUrls: ['./installation-list.component.scss'],
  imports: [
    TranslocoDirective,
    MatIcon,
    MatTable,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatSlideToggle,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    AsyncPipe,
    DatePipe,
  ],
})
export class InstallationListComponent implements OnDestroy {
  readonly displayedColumns = ['leftBorder', 'toggle', 'installationType', 'exigence', 'installationDate', 'lastControlDate'];
  readonly installations$ = this.store.select(selectTechnicalInstallations);

  activeInstallations$ = this.installations$.pipe(map(list => list.filter(i => i.status === 'ACTIVE')));

  inactiveInstallations$ = this.installations$.pipe(map(list => list.filter(i => i.status === 'INACTIVE')));
  readonly buildingIdSubscription = (this.route.parent ?? this.route).params.subscribe(params => {
    this.buildingId = params.buildingId;
    this.store.dispatch(getInstallations({ buildingId: this.buildingId }));
  });
  private buildingId: number;

  constructor(private store: Store, private route: ActivatedRoute, private dialogService: DialogService) {}

  ngOnDestroy(): void {
    this.buildingIdSubscription.unsubscribe();
  }

  async selectInstallation(installation: TechnicalInstallation) {
    const result = await firstValueFrom(
      this.dialogService.openDialogComponent<TechnicalInstallation>(
        AnnouncementFormDialogComponent,
        {
          defaultValue: installation,
          buildingId: this.buildingId,
        },
        'sibat-responsive-dialog'
      )
    );

    if (result) {
      this.store.dispatch(
        updateAnnouncement({
          installationId: installation.id,
          form: result,
          buildingId: this.buildingId,
        })
      );
    }
  }

  onToggleChange(installation: TechnicalInstallation, isChecked: boolean): void {
    const updated: TechnicalInstallation = { ...installation, status: isChecked ? 'ACTIVE' : 'INACTIVE' };

    this.store.dispatch(
      updateAnnouncement({
        installationId: updated.id,
        form: updated,
        buildingId: this.buildingId,
      })
    );
  }
}
